import styled from 'styled-components';

const TableFoot = styled.div`
  display: table-footer-group;
  background-color: gray;
  font-weight: bold;
  font-size: 25px;
  color: rgba(255, 255, 255, 0.45);
`;

export default TableFoot;
